"use client";
import { useEffect, useState } from "react";
const useDetectTouchDevice = ()=>{
    const [isTouchDevice, setIsTouchDevice] = useState(false);
    useEffect(()=>{
        const hasTouchCapability = Boolean(globalThis.window && 'ontouchstart' in globalThis.window);
        setIsTouchDevice(hasTouchCapability);
    }, []);
    return isTouchDevice;
};
export { useDetectTouchDevice };
